<p-button class="flex h-100" (click)="op.toggle($event)" [label]="label()" icon="pi pi-chevron-down" iconPos="right" />
<p-popover #op>
  <div class="popover-content">
    @for (option of advancedSearchOptions; track option) {
      <div class="option" [class.selected]="selectedValue === option.value" (click)="selectOption(option); op.hide()">
        <span>{{ option.label }}</span>
      </div>
    }
  </div>
</p-popover>
